// removed by extract-text-webpack-plugin
module.exports = {"ipad":"1024px","large":"1600px","sideNavCollapsed":"60px","sideNavExpanded":"184px","normal":".3s"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/foundations/Grids/SideNav.css
// module id = 801
// module chunks = 0